"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasInvalidPolicySections = void 0;
const hasInvalidPolicySections = (policies) => {
    const invalidSections = [];
    if (policies?.caddies?.enabled === "UNKNOWN")
        invalidSections.push("Caddies");
    if (policies?.carts?.enabled === "UNKNOWN")
        invalidSections.push("Carts");
    if (policies?.advance_booking?.enabled === "UNKNOWN")
        invalidSections.push("Advance Booking");
    // if (policies?.cancellation?.enabled === 'UNKNOWN')
    //   invalidSections.push('Cancellation')
    if (policies?.handicap_requirements?.enabled === "UNKNOWN")
        invalidSections.push("Handicap Requirements");
    if (policies?.identity_requirement?.enabled === "UNKNOWN")
        invalidSections.push("Identity Requirement");
    if (policies?.nationality_restriction?.enabled === "UNKNOWN")
        invalidSections.push("Nationality Restriction");
    // if (policies?.non_playing_followers?.enabled === 'UNKNOWN')
    //   invalidSections.push('Non Playing Followers')
    if (policies?.raincheck?.enabled === "UNKNOWN")
        invalidSections.push("Raincheck");
    return invalidSections;
};
exports.hasInvalidPolicySections = hasInvalidPolicySections;
